import ko from './ko';
import en from './en';

// 지원 언어 목록
export const SUPPORTED_LANGUAGES = {
  ko: {
    code: 'ko',
    name: '한국어',
    flag: '🇰🇷',
  },
  en: {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
  },
};

// 기본 언어
export const DEFAULT_LANGUAGE = 'ko';

// 언어 팩 매핑
const languages = {
  ko,
  en,
};

/**
 * 언어 팩 가져오기
 * @param {string} languageCode - 언어 코드 (ko, en)
 * @returns {object} 언어 팩 객체
 */
export function getLanguagePack(languageCode) {
  return languages[languageCode] || languages[DEFAULT_LANGUAGE];
}

/**
 * 중첩된 객체에서 키 경로로 값 가져오기
 * 예: t('header.title') → ko.header.title
 * @param {object} obj - 언어 팩 객체
 * @param {string} path - 점(.)으로 구분된 키 경로
 * @returns {string} 번역된 텍스트
 */
export function getNestedValue(obj, path) {
  return path.split('.').reduce((current, key) => current?.[key], obj) || path;
}

export default languages;

